'use strict';

angular
  .module('systemOwnerReviewControllers.DecommissionSystems')

  .controller('DecommissionSystemsController', [
    '$scope',
    '$state',
    '$translate',
    'topBar',
    'systemsToReview',
    function ($scope, $state, $translate, topBar, systemsToReview) {
      // When no selected system type, then go to the first one
      if ($state.is('systemOwnerReview.authUser.decommissionSystems')) {
        if (systemsToReview.length > 0) {
          var firstSystem = systemsToReview[0];
          $state.go('systemOwnerReview.authUser.decommissionSystems.bySystemType', {
            systemTypeSlug: firstSystem.SystemTypeSlug,
            authLogin: $scope.authLogin,
          });
        }
      }

      // Misc
      $translate('iam.admin.systemOwnerReview.decommissionSystems.pageTitle').then(function (translation) {
        topBar.setTitleAndIcon(translation, 'fa-chain-broken');
      });

      // Review a system type
      $scope.goToReviewSystemType = function (systemType) {
        $state.go(
          'systemOwnerReview.authUser.decommissionSystems.bySystemType',
          {
            systemTypeSlug: systemType.Slug ? systemType.Slug : systemType.SystemTypeSlug,
            authLogin: $scope.authLogin,
          },
          { reload: true }
        );
      };

      // Current state, is for this system type ?
      $scope.isReviewForSystemType = function (systemType) {
        return (
          $state.includes('systemOwnerReview.authUser.decommissionSystems.bySystemType') &&
          $state.params.systemTypeSlug === systemType.Slug
        );
      };
    },
  ]);
